import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "page",
  id: "page"
};
const _hoisted_2 = {
  class: "section-md",
  style: {
    "padding-top": "20px"
  }
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "row row-5 row-gutters-20 row-offset-lg person-poster-container"
};
const _hoisted_5 = {
  key: 0,
  style: {
    "width": "100%",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_6 = {
  class: "row person person-boxed",
  "data-animate": "{\"class\":\"fadeInUpBig\"}"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "person-inner col-6 col-xs-6 col-sm-6 col-md-12 col-lg-12"
};
const _hoisted_9 = {
  class: "person-title text-primary"
};
const _hoisted_10 = {
  class: "text-primary"
};
const _hoisted_11 = {
  key: 0,
  class: "person-inner-item yidong-right",
  style: {
    "position": "absolute",
    "right": "0",
    "bottom": "0",
    "z-index": "10",
    "width": "30px",
    "height": "30px"
  }
};
const _hoisted_12 = {
  key: 1,
  class: "person-inner-item pc-right"
};
const _hoisted_13 = {
  key: 0,
  class: "text-primary text-center loading-indicator"
};
const _hoisted_14 = {
  key: 1,
  class: "text-primary text-center no-more-data"
};
import { onMounted, onBeforeUnmount, ref, reactive, computed, nextTick } from 'vue';
import { lawyersList as lawyerListHttp, addressList } from '@/api/home/index';
import { bannerList as bannerListHttp } from '@/api/home';
import { useThrottleFn, useDebounceFn } from '@vueuse/core';
export default {
  __name: 'lawyers',
  setup(__props) {
    const isMobile = computed(() => {
      return navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i);
    });
    const path = computed(() => {
      return process.env.VUE_APP_BASE_ADDRESS;
    });

    // 顶部图片
    const bg = ref('');
    const getBanner = async () => {
      const data = await bannerListHttp({
        type: 'lawyer'
      });
      if (data?.length > 0) {
        for (const item of data) {
          if (item.src && !item.src.startsWith('http')) item.src = path.value + item.src;
        }
        bg.value = data[0]?.src;
      }
    };

    // 律师
    const lawyerList = ref([]);
    const loading = ref(false); // 加载状态标志
    const noMoreData = ref(false); // 是否没有更多数据

    const querySearch = reactive({
      name: '',
      surname: '',
      // 擅长领域
      description: '',
      // 地区
      address_id: ''
    });
    const surnameArr = [{
      value: 'A'
    }, {
      value: 'B'
    }, {
      value: 'C'
    }, {
      value: 'D'
    }, {
      value: 'E'
    }, {
      value: 'F'
    }, {
      value: 'G'
    }, {
      value: 'H'
    }, {
      value: 'I'
    }, {
      value: 'J'
    }, {
      value: 'K'
    }, {
      value: 'L'
    }, {
      value: 'M'
    }, {
      value: 'N'
    }, {
      value: 'O'
    }, {
      value: 'P'
    }, {
      value: 'Q'
    }, {
      value: 'R'
    }, {
      value: 'S'
    }, {
      value: 'T'
    }, {
      value: 'U'
    }, {
      value: 'V'
    }, {
      value: 'W'
    }, {
      value: 'X'
    }, {
      value: 'Y'
    }, {
      value: 'Z'
    }];
    const noData = ref(false);
    const getData = async (page = 1) => {
      if (loading.value || noMoreData.value) return; // 如果已经在加载中，直接返回
      loading.value = true; // 设置加载状态为 true
      try {
        const surname = typeof querySearch.surname === 'string' ? querySearch.surname.toLowerCase() : '';
        const {
          list,
          total
        } = await lawyerListHttp({
          name: querySearch.name,
          surname,
          description: querySearch.description,
          address_id: querySearch.address_id,
          page,
          pageSize: 20
        });
        if (list?.length > 0) {
          if (noData.value) noData.value = false;
          for (const item of list) {
            if (item?.avatar && !item.avatar.startsWith('http')) item.avatar = path.value + item.avatar;
          }
          // 没有更多数据了，如果最后一页恰好是20，则会出错
          // noMoreData.value = list.length < 20;
          // 改为基于总数据量和已加载数据的判断
          const loadedCount = lawyerList.value.length + list.length;
          noMoreData.value = loadedCount >= total;
          if (page == 1) {
            lawyerList.value = [];
          }
          lawyerList.value.push(...list);
        } else {
          noData.value = true;
          // 没有更多数据了
          noMoreData.value = true;
          if (lawyerList.value.length != 0) {
            lawyerList.value = [];
          }
        }
      } catch (error) {
        console.error('加载数据失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const scrollbarRef = ref(null);

    // el-scrollbar滚动事件
    const scrollFn = useThrottleFn(e => {
      const {
        clientHeight,
        scrollHeight,
        scrollTop
      } = scrollbarRef.value?.wrapRef;
      if (scrollbarRef.value && !loading.value && !noMoreData.value) {
        // 计算距离底部的距离
        const distanceToBottom = scrollHeight - clientHeight - scrollTop;
        // console.log(distanceToBottom, '***计算距离底部的距离***');
        if (distanceToBottom <= 1500) {
          // 触发加载更多数据的函数
          getData(Math.ceil(lawyerList.value.length) / 20 + 1);
        }
      }
      // 获取滚动条高度
      // console.log(e, '***5566665***', e.scrollTop);
    });
    const handleScroll = useThrottleFn(e => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const clientHeight = document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight;
      // console.log(distanceToBottom, '***计算距离底部的距离***');
      const distanceToBottom = scrollHeight - clientHeight - scrollTop;

      // console.log('距离底部的距离distanceToBottom', distanceToBottom);

      if (!loading.value && !noMoreData.value) {
        if (distanceToBottom <= 1500) {
          // 触发加载更多数据的函数
          getData(Math.ceil(lawyerList.value.length) / 20 + 1);
        }
      }
    });
    const searchFn = () => {
      useDebounceFn(() => {
        noMoreData.value = false;
        getData(1);
      }, 500)();
    };
    const resetFn = () => {
      useDebounceFn(() => {
        querySearch.name = '';
        loading.value = false;
        noMoreData.value = false;
        querySearch.surname = '';
        querySearch.description = '';
        querySearch.address_id = '';
        getData(1);
      }, 500)();
    };
    const addressDataList = ref([]);
    const getAddressData = async () => {
      const data = await addressList();
      if (data?.length > 0) {
        for (const item of data) {
          if (item.city.includes('分所')) {
            item.cityStr = item.city.split('分所')[0] + '办公室';
          }
          if (item.city.includes('总部')) {
            item.cityStr = item.city.split('总部')[0] + '办公室';
          }
        }
        addressDataList.value = data;
      }
    };
    onMounted(async () => {
      getBanner();
      nextTick(() => {
        getData();
        document.addEventListener('scroll', handleScroll);
      });
      // 搜索地区
      getAddressData();
    });
    onBeforeUnmount(() => {
      document.removeEventListener('scroll', handleScroll);
    });
    return (_ctx, _cache) => {
      const _component_Preload = _resolveComponent("Preload");
      const _component_Header = _resolveComponent("Header");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_router_link = _resolveComponent("router-link");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Preload), _createElementVNode("div", _hoisted_1, [_createVNode(_component_Header, {
        title: "冀华精英",
        bg: bg.value
      }, null, 8, ["bg"]), _createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[7] || (_cache[7] = _createElementVNode("h2", {
        class: "text-center text-divider text-divider-center"
      }, "我们的团队", -1)), _createVNode(_component_el_form, {
        model: querySearch,
        "label-width": "auto",
        class: "row row-5 row-gutters-20 row-offset-lg justify-content-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "姓名",
          class: "col-12 col-sm-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: querySearch.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => querySearch.name = $event),
            modelModifiers: {
              trim: true
            },
            placeholder: "请输入姓名",
            clearable: "",
            maxlength: "20"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "首字母",
          class: "col-12 col-sm-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: querySearch.surname,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => querySearch.surname = $event),
            modelModifiers: {
              trim: true
            },
            "popper-class": "my_select",
            "fit-input-width": "",
            placeholder: "首字母",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(surnameArr, item => {
              return _createVNode(_component_el_option, {
                key: item.value,
                label: item.value,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "擅长领域",
          class: "col-12 col-sm-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: querySearch.description,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => querySearch.description = $event),
            modelModifiers: {
              trim: true
            },
            placeholder: "请输入擅长领域",
            clearable: "",
            maxlength: "20"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "地区",
          class: "col-12 col-sm-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: querySearch.address_id,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => querySearch.address_id = $event),
            modelModifiers: {
              trim: true
            },
            "fit-input-width": "",
            placeholder: "地区",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressDataList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.cityStr,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createElementVNode("div", {
        class: "row row-gutters-20 justify-content-center",
        style: {
          "margin-top": "10px"
        }
      }, [_createElementVNode("div", {
        class: "col-12 col-sm-3",
        style: {
          "margin": "4px 10px",
          "padding": "4px 0",
          "color": "#FFF",
          "cursor": "pointer",
          "user-select": "none",
          "border-radius": "4px",
          "display": "flex",
          "justify-content": "center",
          "background-color": "#CDA873"
        },
        onClick: searchFn
      }, " 搜 索"), _createElementVNode("div", {
        class: "col-12 col-sm-3",
        style: {
          "margin": "4px 10px",
          "padding": "4px 0",
          "color": "#FFF",
          "cursor": "pointer",
          "user-select": "none",
          "border-radius": "4px",
          "display": "flex",
          "justify-content": "center",
          "background-color": "#CDA873"
        },
        onClick: resetFn
      }, " 重 置")]), _createElementVNode("div", _hoisted_4, [noData.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_empty, {
        description: "空空如也"
      })])) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(lawyerList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3",
          key: item.id
        }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_router_link, {
          to: '/team-member?id=' + item.id,
          class: "team-member-img col-6 col-xs-6 col-sm-6 col-md-12 col-lg-12"
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            class: "person-img",
            style: {
              "object-fit": "cover",
              "object-position": "top",
              "width": "100%",
              "max-height": "320px"
            },
            src: item?.avatar,
            alt: ""
          }, null, 8, _hoisted_7)]),
          _: 2
        }, 1032, ["to"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
          class: _normalizeClass(["person-inner-item", [isMobile.value ? 'mobileStyle' : 'person-content']])
        }, [_createElementVNode("h4", _hoisted_9, [_createVNode(_component_router_link, {
          to: '/team-member?id=' + item.id
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name) + "律师", 1)]),
          _: 2
        }, 1032, ["to"])]), _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "person-divider"
        }, null, -1)), _createElementVNode("h5", _hoisted_10, _toDisplayString(item?.position || '专职律师'), 1)], 2), isMobile.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_router_link, {
          to: '/team-member?id=' + item.id,
          class: "person-button",
          style: {
            "display": "flex",
            "justify-content": "center",
            "align-content": "center",
            "padding": "0",
            "width": "100%",
            "height": "100%"
          }
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("span", {
            class: "mdi mdi-arrow-right",
            style: {
              "align-content": "center"
            }
          }, null, -1)])),
          _: 2
        }, 1032, ["to"])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_router_link, {
          to: '/team-member?id=' + item.id,
          class: "person-button"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("span", {
            class: "mdi mdi-arrow-right"
          }, null, -1)])),
          _: 2
        }, 1032, ["to"])]))])])]);
      }), 128))])])]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, "加载中...")) : _createCommentVNode("", true), noMoreData.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, "没有更多数据了")) : _createCommentVNode("", true), _createVNode(_component_Footer)])], 64);
    };
  }
};